const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 80,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 110,
	},
	{
		prop: "IsProviderName",
		label: "仅授权不订货",
		columnwidth: 120,
	},
	{
		prop: "RejectReason",
		label: "驳回原因",
		columnwidth: 150,
	},
	{
		prop: "RevokeReason",
		label: "撤回原因",
		columnwidth: 150,
	},
	{
		prop: "CusName",
		label: "经销商",
		columnwidth: 200,
	},
	{
		prop: "BOSSName",
		label: "公司负责人",
		columnwidth: 150,
	},
	{
		prop: "CompanyName",
		label: "上游经销商",
		columnwidth: 200,
	},
	{
		prop: "HospitalName",
		label: "医院",
		columnwidth: 200,
	},
	{
		prop: "Remark",
		label: "申请原因",
		columnwidth: 150,
	},
	{
		prop: "InvClassName",
		label: "产品线名称",
		columnwidth: 110,
	},
	{
		prop: "RejecterName",
		label: "驳回人",
		columnwidth: 150,
	},
	{
		prop: "RejectTime",
		label: "驳回时间",
		columnwidth: 150,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 110,
	},
	{
		prop: "SubmitterName",
		label: "提交人",
		columnwidth: 150,
	},
	{
		prop: "SubmitTime",
		label: "提交时间",
		columnwidth: 150,
	},
	{
		prop: "FileLinkMan",
		label: "文件联系人",
		columnwidth: 150,
	},
	{
		prop: "FileLinkTel",
		label: "文件联系方式",
		columnwidth: 150,
	},
	{
		prop: "FileEMail",
		label: "文件联系人邮箱",
		columnwidth: 150,
	},
	{
		prop: "FileReceiveAddress",
		label: "文件收件地址",
		columnwidth: 170,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 95,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 110,
	},
	{
		prop: "ApproverName",
		label: "审批通过人",
		columnwidth: 125,
	},
	{
		prop: "ApproveTime",
		label: "审批通过时间",
		columnwidth: 150,
	},
	{
		prop: "ApplyType",
		label: "申请类型",
		columnwidth: 150,
	},
	{
		prop: "ApplyCode",
		label: "申请单号",
		columnwidth: 150,
	},
	{
		prop: "NeedBossApprovalName",
		label: "是否需要高层审批",
		columnwidth: 130,
	},
	{
		prop: "OpenAccountStatusName",
		label: "开户状态名称",
		columnwidth: 150,
	},
	{
		prop: "BuyFromHomeName",
		label: "是否从公司订货",
		columnwidth: 150,
	},

	{
		prop: "CusCode",
		label: "经销商编号",
		columnwidth: 150,
	},
];
export default headerData